export default __webpack_public_path__ + "static/media/Amanda.718a7082.png";